(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.setHeaderHeight = () => document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      new IntersectionObserver((entries, obs) => { this.headerBounds = entries[0].intersectionRect; obs.disconnect(); }).observe(this.header);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    onScroll() {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      if (top > this.currentScrollTop && top > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (top < this.currentScrollTop && top > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else { clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => (this.preventReveal = false), 66); requestAnimationFrame(this.hide.bind(this)); }
      } else if (top <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = top;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.querySelector('details-modal[open], details[open] > .search-modal')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.querySelectorAll('.pmh__item.is-open').forEach((el) => el.classList.remove('is-open'));
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
